import { PROVIDER__toast } from '@/components/ui/toasts/PROVIDER__toast';
import { TooltipProvider } from '@/components/ui/tooltip';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_network } from '@/hooks/store/use_slices';
import i18n_network from '@/locales/keys/i18n_network.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { service_socketio_client } from '@/services/socketio_client_react/service_socketio_client';
import { assert_record_value } from '@shared/asserts/utils_asserts';
import { useTranslation } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '../components/theme/theme_provider';
import { ENUM__connection_state } from '../enums/ENUM__connection_state';
import { ViewAllHintsShortcuts } from '../pages/_base/modals/ViewAllHintsShortcuts';
import { ViewHintsShortcutContainer } from '../pages/_base/shortcut_hint/ViewHintsShortcutContainer';
import { SPLASH__loading } from '../pages/_base/views/splash/SPLASH__loading';
import { remote_network_connect } from '../state/network/remote_network_connect';
import { APP__routes } from './APP__routes';
import { WATCHERS__container_global_after_view } from './WATCHERS__container_global_after_view';
import { WATCHERS__container_global_before_view } from './WATCHERS__container_global_before_view';

interface PROPS {}
export function APP__initializer({}: PROPS) {
  const dispatch = use_dispatch();

  const { t } = useTranslation(ENUM__i18n_namespace.NETWORK);

  const { state } = use_slice_network(['state']);

  /*
   * EFFECTS
   */
  use_effect(() => {
    service_socketio_client.disconnect();

    void dispatch(remote_network_connect());
  });

  /*
   * METHODS
   */

  function render_view() {
    let out = null;

    if (state == ENUM__connection_state.CONNECTING) {
      out = null;
    } else if (state === ENUM__connection_state.CONNECTION_ESTABLISHED) {
      out = <APP__routes />;
    } else {
      let map: any = new Object();
      map[ENUM__connection_state.CONNECTION_ESTABLISHED] = i18n_network.connection.established;
      map[ENUM__connection_state.CONNECTION_ERROR] = i18n_network.connection.error;
      map[ENUM__connection_state.CONNECTING] = i18n_network.connection.connecting;
      map[ENUM__connection_state.DISCONNECTED] = i18n_network.connection.disconnected;

      assert_record_value(map, state);

      out = null;
    }

    return out;
  }

  return (
    <>
      <ThemeProvider>
        <BrowserRouter>
          <SPLASH__loading />

          <TooltipProvider>
            <PROVIDER__toast />

            {/*
             * VIEWS
             */}
            <ViewHintsShortcutContainer />
            {/*
             * VIEWS FULLSCREEN
             */}

            <ViewAllHintsShortcuts />

            <WATCHERS__container_global_before_view />

            {render_view()}

            <WATCHERS__container_global_after_view />
          </TooltipProvider>
        </BrowserRouter>
      </ThemeProvider>
    </>
  );
}
